import { useCollections } from '../../features/catalog/queries.js';

/**
 * The one list of links the masthead and the mobile menu both draw.
 *
 * Flat on purpose: no dropdowns, no "New in", "Sale" or "Shop all". After Home
 * comes every published collection, in the order the Collections screen sets —
 * a collection an operator creates appears here with no deploy, a rename shows
 * up under the new name, and one set to draft drops out. The full catalogue is
 * still one click away from every collection page and the footer.
 *
 * Categories are deliberately not in the bar. A category usually lives inside a
 * collection, so listing both put "Fragrance" and "Attars and oils" side by
 * side for the same six products. Categories are reached from the shop's
 * filters and from each collection's page.
 *
 * Blogs, About and Contact are marked `secondary`: the desktop bar shows them
 * only where there is room, and they are always in the mobile menu and footer.
 */

const MAX_COLLECTIONS = 6;

export const useNavLinks = () => {
  // Published collections only, already ordered by the API.
  const { data: collections } = useCollections();

  const worlds = (collections ?? []).slice(0, MAX_COLLECTIONS).map((collection) => ({
    to: `/shop?world=${collection.slug}`,
    label: collection.name,
    isActive: ({ pathname, search }) =>
      pathname === '/shop' && new URLSearchParams(search).get('world') === collection.slug,
  }));

  return [
    { to: '/', label: 'Home', isActive: ({ pathname }) => pathname === '/' },
    ...worlds,
    { to: '/blogs', label: 'Blogs', secondary: true, isActive: ({ pathname }) => pathname.startsWith('/blogs') },
    { to: '/about', label: 'About', secondary: true, isActive: ({ pathname }) => pathname === '/about' },
    { to: '/contact', label: 'Contact', secondary: true, isActive: ({ pathname }) => pathname === '/contact' },
  ];
};

export default useNavLinks;
